import { $api } from '@service/RequestService';
import { useMutation, useQueryClient } from 'react-query';

import { clientConstants } from 'modules/client';

import { cashbackConstants } from '..';

export const useCashbackPaymentInOutSave = () => {
  const qc = useQueryClient();

  return useMutation(
    async (data: {
      type: 'in' | 'out';
      data: {
        payment: {
          id?: number;
          paymentCustomTypeId?: number;
          paymentCustomTypeName?: string;
          amount: number;
          type: string;
          currencyId: number;
          note?: string;
          debit?: string;
        };
        cashbackBalanceId: number;
        id?: number;
      };
    }) => {
      if (data?.type === 'out') {
        const res = await $api.post('/v1/cashback-payment/withdraw', data?.data);

        return res.data;
      }
      const res = await $api.post('/v1/cashback-payment/top-up', data?.data);

      return res.data;
    },
    {
      onSuccess: () => {
        qc.invalidateQueries([clientConstants.queryKeys.CLIENT_CASHBACK]);
        qc.invalidateQueries([cashbackConstants.queryKeys.CASHBACK_PAYMENT_FILTER]);
      }
    }
  );
};
